import {Checkbox} from 'platform/components';

import {MakeAndChecked} from '../utils/types';

export interface TopMakeRowProps {
  readonly make: MakeAndChecked;
  readonly handleRowToggle: (makeCode: string) => void;
}

export const TopMakeRow = ({make, handleRowToggle}: TopMakeRowProps) => (
  <Checkbox
    label={make.label}
    value={!!make.checked}
    onChange={() => handleRowToggle(make.value)}
  />
);
